import React, { useState } from "react";
import { useEffect } from "react";
import { Accordion } from "react-bootstrap-accordion";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import WOW from "wowjs";
import { Icon } from "@iconify/react";
import ClientLogo from "../../Shared/ClientLogo";
import { Helmet } from "react-helmet-async";

const FilmsService = (props) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  useEffect(() => {
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
  }, []);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>

      <Helmet>
        <title>Film & Corporate Video Production Company in Mumbai, India- Reverse Thought</title>
        <meta name="description" content="As a top-notch video production company in Mumbai, India, Reverse Thought offers unrivaled video production services supported by years of expertise in the industry. " />
        <meta name="robots" content="max-image-preview:large" />
        <meta name="google-site-verification" content="HoCjksaLBwM7qPH8Nt-Rzrqa5K02wXYiJwFSEMC4j8g" />
        <meta name="p:domain_verify" content="f307b6f44d53f755ef67d9a9a3666de7" />
        <meta name="keywords" content="best film production companies in mumbai,corporate video makers in mumbai,corporate video mumbai,corporate video production in mumbai,film production companies in mumbai,video production company in mumbai,video production mumbai,video production services in india,video production services in mumbai,animated video production,corporate video production company,corporate video production mumbai,explainer video production,video production company,corporate video production india" />
        <link rel="canonical" href="https://www.reversethought.com/video-production/" />
        <meta name="generator" content="All in One SEO (AIOSEO) 4.4.7.1" />
        <meta name="Keywords" content="video production company in Mumbai,video production services in India,Video Production Company In India,Video Production Agency India, Corporate Video Production, explainer video company in USA "></meta>
        <meta property="og:locale" content="en_US" />
        <meta property="og:site_name" content="Creative Agency In Mumbai | Branding Agency India - Reverse Thought" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Film &amp; Corporate Video Production Company in Mumbai, India" />
        <meta property="og:description" content="We create film &amp; corporate videos that instantly engages with the audience. We also create explainer videos, case study videos, 2D &amp; 3D Animated videos that grabs attention quickly." />
        <meta property="og:url" content="https://www.reversethought.com/video-production" />
        <meta property="article:tag" content="best film production companies in mumbai" />
        <meta property="article:tag" content="corporate video makers in mumbai" />
        <meta property="article:tag" content="corporate video mumbai" />
        <meta property="article:tag" content="corporate video production in mumbai" />
        <meta property="article:tag" content="film production companies in mumbai" />
        <meta property="article:tag" content="video production company in mumbai" />
        <meta property="article:tag" content="video production mumbai" />
        <meta property="article:tag" content="video production services in india" />
        <meta property="article:tag" content="video production services in mumbai" />
        <meta property="article:tag" content="animated video production" />
        <meta property="article:tag" content="corporate video production company" />
        <meta property="article:tag" content="corporate video production mumbai" />
        <meta property="article:tag" content="explainer video production" />
        <meta property="article:tag" content="video production company" />
        <meta property="article:tag" content="explainer video company in USA" />
        <meta property="article:tag" content="corporate video production india" />
        <meta property="article:published_time" content="2018-12-26T08:10:16+00:00" />
        <meta property="article:modified_time" content="2023-07-12T12:51:11+00:00" />
        <meta property="article:publisher" content="https://www.facebook.com/rtcspl/" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@rthoughtindia" />
        <meta name="twitter:title" content="Film &amp; Corporate Video Production Company in Mumbai, India" />
        <meta name="twitter:description" content="We create film &amp; corporate videos that instantly engages with the audience. We also create explainer videos, case study videos, 2D &amp; 3D Animated videos that grabs attention quickly." />
        <meta name="google" content="nositelinkssearchbox" />
     
      </Helmet>
      <h1 className="d-none">video production company in Mumbai, India</h1>
      <h2 className="d-none">video production services in India</h2>
      <h2 className="d-none">Video Production Agency India</h2>
      <h3 className="d-none">Video Production Company In India</h3>
      <h3 className="d-none">Corporate Video Production</h3>
      <h3 className="d-none">explainer video company in USA</h3>
      <section className="servicePageSection webServicePageSection filmsService position-relative">
        <div className="content_container position-relative">
          <img
            src="/images/films-service.png"
            alt="films-service"
            className="filmsServiceVector"
          />
          <div className="servicePageBanner">
            <h3 className="colorBlack fw-800 projectHeading wow animate__animated animate__fadeInUp">
              Transform Your Vision <br />
              into Stunning Films
            </h3>

            <h4 className="serviceKeyPoints colorBlack fw-800 wow animate__animated animate__fadeInUp animation_delay_100ms">
              Frame.
            </h4>
            <h4 className="serviceKeyPoints colorBlack fw-800 wow animate__animated animate__fadeInUp animation_delay_200ms">
              Story.
            </h4>
            <h4 className="serviceKeyPoints colorBlue fw-800 wow animate__animated animate__fadeInUp animation_delay_300ms">
              Magic.
            </h4>
          </div>
        </div>
      </section>

      <section className="webServiceWhatWeDo whatWeDo">
        <div className="content_container">
          <h3 className="sectionHead colorBlack fw-800 wow">
            <img src="/images/icons/line.svg" alt="line" />
            Our Video Production Services
          </h3>
          <div className="row m-0 whatwedoTabs">
            <div className="col-sm-6 p-0 whatwedoTabsL">
              <ul>
                <li
                  onClick={() => handleTabClick(0)}
                  className={
                    activeTab === 0
                      ? "wow animate__animated animate__fadeInUp active"
                      : "wow animate__animated animate__fadeInUp"
                  }
                >
                  {/* <span className="fw-800">01</span> */}
                  Explainer Videos
                </li>
                <li
                  onClick={() => handleTabClick(1)}
                  className={
                    activeTab === 1
                      ? "wow animate__animated animate__fadeInUp active"
                      : "wow animate__animated animate__fadeInUp"
                  }
                >
                  {/* <span className="fw-800">02</span> */}
                  Corporate Videos & Documentaries
                </li>
                <li
                  onClick={() => handleTabClick(2)}
                  className={
                    activeTab === 2
                      ? "wow animate__animated animate__fadeInUp active"
                      : "wow animate__animated animate__fadeInUp"
                  }
                >
                  {/* <span className="fw-800">03</span> */}
                  2D/3D Animation
                </li>
                <li
                  onClick={() => handleTabClick(3)}
                  className={
                    activeTab === 3
                      ? "wow animate__animated animate__fadeInUp active"
                      : "wow animate__animated animate__fadeInUp"
                  }
                >
                  {/* <span className="fw-800">04</span> */}
                  Social Media Films
                </li>
              </ul>
            </div>
            <div className="col-sm-6 p-0 whatwedoTabsR wow animate__animated animate__fadeInUp animation_delay_300ms">
              {activeTab === 0 && (
                <div
                  className={
                    activeTab === 0
                      ? "whatWeDoTabsResult wow animate__animated animate__fadeInLeft"
                      : "whatWeDoTabsResult"
                  }
                >
                  {/* 30 April 2024 ---- <p className="colorBlack fw-400">
                    Demonstrate the convenience that your product or service
                    provides, easily impart user instructions, training and many
                    more things with intelligently scripted and executed 2D & 3D
                    explainer videos. We have the capability to execute films in
                    20 international languages and all major Indian languages.
                  </p> */}
                  <p className="colorBlack fw-400">
                    Demonstrate the convenience that your product or service provides, easily impart user instructions,
                    training and many more things with intelligently scripted and executed 2D &amp; 3D explainer videos. We,
                    the best explainer video company in USA, have the capability to execute films in 20 international
                    languages and all major Indian languages.
                  </p>
                  <a
                    href="/works/video-production"
                    className="unsetAll"
                    // onClick={() => window.scrollTo(0, 0)}
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    <span className="commonViewAll linksYw_hover colorBlue">Learn More</span>
                    <Icon icon="clarity:arrow-line" />
                  </a>
                </div>
              )}
              {activeTab === 1 && (
                <div
                  className={
                    activeTab === 1
                      ? "whatWeDoTabsResult wow animate__animated animate__fadeInLeft"
                      : "whatWeDoTabsResult"
                  }
                >
                  {/* 30 April 2024 ---- <p className="colorBlack fw-400">
                  We have helped several companies showcase their manufacturing,
                  technical and people strengths in an immersive, story-based
                narrative. An entire team of highly creative and technical
                people come together to script, shoot, edit and package your
                video. Beautiful drone assisted and ground level photography,
                slick animation and sharp editing create an outstanding product.
                We have proven expertise in conducting shoots at international
                locations within affordable budgets.
                  </p> */}
                  <p className="colorBlack fw-400">
                    We have helped several companies showcase their manufacturing, technical and people strengths in an
                    immersive, story-based narrative. An entire team of highly creative and technical people come together
                    to script, shoot, edit and package your Corporate Video Production. Beautiful drone assisted and
                    ground level photography, slick animation and sharp editing create an outstanding product. We have
                    proven expertise in conducting shoots at international locations within affordable budgets.
                  </p>
                  <a
                    href="/works/video-production"
                    className="unsetAll"
                    // onClick={() => window.scrollTo(0, 0)}
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    <span className="commonViewAll linksYw_hover colorBlue">Learn More</span>
                    <Icon icon="clarity:arrow-line" />
                  </a>
                </div>
              )}
              {activeTab === 2 && (
                <div
                  className={
                    activeTab === 2
                      ? "whatWeDoTabsResult wow animate__animated animate__fadeInLeft"
                      : "whatWeDoTabsResult"
                  }
                >
                  <p className="colorBlack fw-400">
                  Challenging concepts become simple and engaging when visualised.
                From engineering to medical, our 3d animated videos have helped
                companies explain complex topics in a simple and visually
                engaging manner. 2d animation can turn any AV into an enjoyable
                experience – be it explainer videos, testimonial videos or
                finance videos for investors.
                  </p>
                  <a
                    href="/works/video-production"
                    className="unsetAll"
                    // onClick={() => window.scrollTo(0, 0)}
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    <span className="commonViewAll linksYw_hover colorBlue">Learn More</span>
                    <Icon icon="clarity:arrow-line" />
                  </a>
                </div>
              )}
              {activeTab === 3 && (
                <div
                  className={
                    activeTab === 3
                      ? "whatWeDoTabsResult wow animate__animated animate__fadeInLeft"
                      : "whatWeDoTabsResult"
                  }
                >
                  <p className="colorBlack fw-400">
                    Unlock the power of storytelling with our service, turning
                    your moments into captivating cinematic experiences that
                    leave a lasting impression on your audience.
                  </p>
                  <a
                    href="/works/video-production"
                    className="unsetAll"
                    // onClick={() => window.scrollTo(0, 0)}
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    <span className="commonViewAll linksYw_hover colorBlue">Learn More</span>
                    <Icon icon="clarity:arrow-line" />
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <section className="ourWorkSlider ourWorkslider2 wow animate__animated animate__slideInLeft">
        <div className="content_container">
          <h3 className="sectionHead text-dark colorBlack wow fw-800">
            <img src="/images/icons/line.svg" alt="line" />
            Video Production Work
          </h3>
          <Slider {...settings}>
            <div>
              <div className="sliderInner">
              <a href="/icici-prudential" className="text-decoration-none">
                <div className="imgHoverEffect position-relative">
                  <a
                    href="/icici-prudential"
                    className="colorWhite fw-800"
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    View Projects &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="toparrow"
                      className="img-fluid"
                    />
                  </a>
                  <img src="/images/cards/Video/icicipru.jpg" alt="work" />
                </div>
                <h3 className="colorBlack fw-800 pt-3">Icici Prudential</h3>
                <span className="colorGrey fw-400">Video Production</span>
                </a>
              </div>
            </div>
            <div>
              <div className="sliderInner">
              <a href="/recipe" className="text-decoration-none">
                <div className="imgHoverEffect position-relative">
                  <a
                    href="/recipe"
                    className="colorWhite fw-800"
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    View Projects &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="toparrow"
                      className="img-fluid"
                    />
                  </a>
                  <img src="/images/cards/Video/recipe.jpg" alt="work" />
                </div>
                <h3 className="colorBlack fw-800 pt-3">Recipe</h3>
                <span className="colorGrey fw-400">Video Production</span>
                </a>
              </div>
            </div>
            <div>
              <div className="sliderInner">
              <a href="/speak-event" className="text-decoration-none">
                <div className="imgHoverEffect position-relative">
                  <a
                    href="/speak-event"
                    className="colorWhite fw-800"
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    View Projects &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="toparrow"
                      className="img-fluid"
                    />
                  </a>
                  <img src="/images/cards/Video/speakevent.jpg" alt="work" />
                </div>
                <h3 className="colorBlack fw-800 pt-3">Speak Event</h3>
                <span className="colorGrey fw-400">Video Production</span>
                </a>
              </div>
            </div>

            <div>
              <div className="sliderInner">
              <a href="/qr678" className="text-decoration-none">
                <div className="imgHoverEffect position-relative">
                  <a
                    href="/qr678"
                    className="colorWhite fw-800"
                    onMouseEnter={props.onMouseEnterSmall}
                    onMouseLeave={props.onMouseLeaveSmall}
                  >
                    View Projects &nbsp;
                    <img
                      src="/images/icons/topArrowWhite.svg"
                      alt="toparrow"
                      className="img-fluid"
                    />
                  </a>
                  <img src="/images/cards/Video/car.jpg" alt="work" />
                </div>
                <h3 className="colorBlack fw-800 pt-3">QR678</h3>
                <span className="colorGrey fw-400">Video Production</span>
                </a>
              </div>
            </div>
          </Slider>

          <Link
            to="/works/video-production"
            className="unsetAll"
            onClick={() => window.scrollTo(0, 0)}
            onMouseEnter={props.onMouseEnterSmall}
            onMouseLeave={props.onMouseLeaveSmall}
          >
            <span className="commonViewAll colorBlue linksYw_hover">View Our Projects</span>
            <Icon icon="clarity:arrow-line" />
          </Link>
        </div>
      </section>
      <section
        className="ourExpertiseSection wow animate__animated animate__slideInUp"
        onMouseEnter={props.mouseEnterOnBlack}
        onMouseLeave={props.mouseLeaveOnBlack}
      >
        <div className="content_container">
          <h3 className="sectionHead text-white colorWhite fw-800 wow">
            <img src="/images/icons/line-white.svg" alt="line" />
            Our Expertise
          </h3>
          <div className="row">
          <div className="col-sm-6 accordianParent wow animate__animated animate__fadeIn animation_delay_300ms">
            <Accordion title="Project & Process Mapping Videos">
              <p>
                Elevate your project documentation with our time-lapse videos,
                enabling you to showcase the journey of your projects and
                enhance customer comprehension of your manufacturing and service
                delivery processes through informative process videos.
              </p>
            </Accordion>
            <Accordion title="Annual Report Videos">
              <p>
                We specialise in crafting engaging Annual Report Videos that
                effectively convey your company's achievements, milestones, and
                vision, providing stakeholders with a comprehensive overview of
                your organisation's annual performance.
              </p>
            </Accordion>
            <Accordion title="Video Ads">
              <p>
                Most social platforms are now allowing for a variety of ad
                formats with unique advantages. We help you create quick,
                interesting, attention-grabbing video ads that will supercharge
                your advertising efforts.
              </p>
            </Accordion>
            <Accordion title="Process Videos">
              <p>
              Document the progress of your projects and create an impact
                    with our time lapse videos. Help customers understand your
                    manufacturing and service delivery process with process
                    videos.
              </p>
            </Accordion>
            <Accordion title="Social Project Documentaries / CSR Videos">
              <p>
                Translate and communicate the impact you’ve made on-ground and
                spread the word with a social initiative documentary. Whether as
                an NGO or an organisation dedicated to Corporate Social
                Responsibility (CSR) initiatives, just reach out to us and we
                will deliver.
              </p>
            </Accordion></div>
            <div className="col-sm-6 accordianParent wow animate__animated animate__fadeIn animation_delay_300ms">
            <Accordion title="Sales / Training Videos">
              <p>
                When managing a large sales team, how do you ensure that
                everyone is on the same page? Supporting your training modules
                with an intelligently crafted, shareable video can drastically
                improve the performance of your team.
              </p>
            </Accordion>
            <Accordion title="Case Study Videos">
              <p>
                Showcase your successes on a broader canvas with case study
                videos created with passion and creativity. Companies have
                observed that compelling case studies boost customer confidence
                manifold and provide a tangible edge over competition.
              </p>
            </Accordion>
            <Accordion title="Storyboarding">
              <p>
                Storyboarding is a creative and time-consuming process which we
                plan and execute meticulously. We specialise in both Photoshop
                based storyboards and hand-sketched illustrations based on
                individual project requirements.
              </p>
            </Accordion>
            <Accordion title="Social Media Stories">
              <p>
              If you are trying to establish an emotional connection with
                    your audience on social media, it doesn’t get more effective
                    than a beautiful story tied into your product. Leave the
                    story, concept and execution to us and just get ready for
                    the accolades.
              </p>
            </Accordion>
          </div>
          </div>
          <h3 className="sectionHead colorWhite text-white fw-800 wow">
            <img src="/images/icons/line-white.svg" alt="line" />
            Why Choose Us
          </h3>
          <div className="whyChooseUsDetails">
            <p className="colorWhite fw-400 wow animate__animated animate__fadeInUp">
              In the realm of video production, we've consistently shattered
              conventions and stretched the boundaries of creativity to bridge
              the gap between your objectives and the audience's desires. Our
              video production expertise incorporates interactive tools,
              compelling content, captivating visuals, and user-friendly
              interfaces, seamlessly fused with cutting-edge technologies such
              as High tech cameras, Graphics and Animation Software, Virtual
              Reality (VR) and Augmented Reality (AR) Tools, Streaming and
              Delivery Platforms, and more, to craft immersive cinematic
              experiences.
            </p>
            {/* <div className="d-flex align-items-center"> */}
            <ul className="d-flex align-items-center wow animate__animated animate__fadeInUp animation_delay_300ms">
              <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                Motion Capture
              </li>
              <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                Drone Technology
              </li>
              <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                Live Streaming Tools
              </li>
              <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                360-Degree Video Cameras
              </li>
              {/* <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                
              </li> */}
              <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                Audio and Video Codecs
              </li>
              {/* <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                
              </li> */}
              <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                Cloud-Based Collaboration Tools
              </li>
              {/* <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                Collaboration Tools
              </li> */}
              <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                3D Modeling and Rendering
              </li>
              <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                Audio Editing Software
              </li>
              {/* <li
                className="colorWhite fw-800"
                onMouseEnter={props.mouseEnterOnBlack}
                onMouseLeave={props.mouseLeaveOnBlack}
              >
                WordPress
              </li> */}
            </ul>
            {/* </div> */}
          </div>
        </div>
      </section>

      <section className="webServicePageClient ourRecentClients">
        <div className="content_container">
          <h3 className="sectionHead colorBlack fw-800 wow">
            <img src="/images/icons/line.svg" alt="line" />
            Our Recent Clients
          </h3>
          <ClientLogo client="videoClient" />
        </div>
      </section>

      <section className="pt-0 creativeThoughts position-relative">
        <div className="content_container">
          <img
            src="/images/icons/circle-l.png"
            alt="circle-l"
            className="wow animate__animated animate__rotateIn"
          />

          <div className="colorBlack fw-800 company">
            <p className="mb-0 wow">We combines cinematic</p>
            <p className="mb-0 wow">storytelling with cutting-</p>
            <p className="mb-0 wow">edge technology to create</p>
            <p className="mb-0 wow">unforgettable visual</p>
            <p className="mb-0 wow">experiences</p>
          </div>
          <div className="text-end">
            <img
              src="/images/icons/circle-r.png"
              alt="circle-r"
              className="wow animate__animated animate__rotateIn"
            />
          </div>
        </div>
      </section>

      {/* <section style={{backgroundColor:"black", color:"white"}}>
        <div className="content_container">             
          <div className="accordianParent wow animate__animated animate__fadeIn animation_delay_300ms">
            <Accordion title="RT">
              <p>Are you in search for the best video production company in Mumbai, India? Reverse Thought is your right stop. We align your business goals efficiently with our innovative vision and technical expertise.</p>
              <p>We are a full-service Video Production Agency India, transforming imagination to execution. Whether you are an emerging start-up or an well-known brand, we can tell your company’s story and enhance your brand with the best Corporate Video Production.</p>
              <p>As a top video production company, we offer world-class video production services in India. Our video production experts create persuasive and short form videos too for your business.</p>
              <p>Partner with Reverse Thought and unlock the power of compelling video production services in India and draw your audience like never before. </p>
            </Accordion>
          </div>
        </div>
      </section> */}


      
      <section className="aboitUsSection clientsMainSection position-relative">
        <div className="content_container">
          <div className="servicePageBanner">
            {/* <h2 className="colorBlack fw-800 projectHeading wow animate__animated animate__fadeInUp" style={{fontSize: "50px", lineHeight: "normal"}}>
            Boost Your Brand with Reverse Thought - Top Digital Agency in Mumbai
            </h2> */}
            <p className="colorBlack fw-400 projectDesc wow animate__animated animate__fadeInUp animation_delay_300ms pt-1" style={{fontSize: "16px", letterSpacing: "normal", lineHeight:"20px"}}>We are a full-service Video Production Agency India, transforming imagination to execution. Whether you are an emerging start-up or an well-known brand, we can tell your company’s story and enhance your brand with the best Corporate Video Production.</p>
            <p className="colorBlack fw-400 projectDesc wow animate__animated animate__fadeInUp animation_delay_300ms pt-1" style={{fontSize: "16px", letterSpacing: "normal", lineHeight:"20px"}}>Are you in search for the best video production company in Mumbai, India? Reverse Thought is your right stop. We align your business goals efficiently with our innovative vision and technical expertise.</p>
            <p className="colorBlack fw-400 projectDesc wow animate__animated animate__fadeInUp animation_delay_300ms pt-1" style={{fontSize: "16px", letterSpacing: "normal", lineHeight:"20px"}}>As a top video production company, we offer world-class video production services in India. Our video production experts create persuasive and short form videos too for your business.</p>
            <p className="colorBlack fw-400 projectDesc wow animate__animated animate__fadeInUp animation_delay_300ms pt-1" style={{fontSize: "16px", letterSpacing: "normal", lineHeight:"20px"}}>Partner with Reverse Thought and unlock the power of compelling video production services in India and draw your audience like never before. </p>
          </div>
        </div>
      </section>



    </>
  );
};

export default FilmsService;
